import { defineComponent as _defineComponent } from 'vue'
import { HelperViewStatus } from '@warrenbrasil/nebraska-web';

interface Props {
  title: string;
  description: string;
  status: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalStatus',
  props: {
    title: null,
    description: null,
    status: null
  },
  setup(__props: any) {



return { __sfc: true,HelperViewStatus }
}

})